import { NormalizedRegistrationCategory } from '../../set-category/queries';
import { QualificationDisplayCard } from './qualification-display-card';

interface Props {
  categories: NormalizedRegistrationCategory[];
}

export function CompetitionCategoryQualifications({ categories }: Props) {
  return (
    <div style={{ display: 'flex', gap: 'var(--size-3)', flexDirection: 'column' }}>
      {categories.map((category, index) => {
        const disabled = !category.weight_classes.some(weight => weight.limit);
        return <QualificationDisplayCard category={category} key={`category-${index}`} disabled={disabled} />;
      })}
    </div>
  );
}
